import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import Switch from "react-switch";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {},
  ja: {},
  es: {},
});

class TutorialSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userSettings: [],
      tutorialMode: false,
    };

    //? all function
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    fire
      .database()
      .ref("userSettings")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        //? use oppositeBoolean because the switch button take true = enable and false = disable
        //? isTutorialCompleted true = completed and false = not completed
        var oppositeBoolean = null;
        if (snapshot.exists) {
          if (snapshot.val().isTutorialCompleted === true) {
            oppositeBoolean = false;
            this.setState({
              tutorialMode: oppositeBoolean,
            });
          } else {
            oppositeBoolean = true;
            this.setState({
              tutorialMode: oppositeBoolean,
            });
          }
        }
      });
  }

  handleChange() {
    let currentTutorialMode = this.state.tutorialMode;

    const userSettingDB = fire
      .database()
      .ref("userSettings")
      .child(auth.currentUser.uid);

    userSettingDB
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists) {
          if (
            snapshot.val().isTutorialCompleted !== undefined ||
            snapshot.val().isTutorialCompleted !== null
          ) {
            userSettingDB.update({
              isTutorialCompleted: currentTutorialMode,
            });
          }
        }
      })
      .then(() => {
        this.setState({
          tutorialMode: !currentTutorialMode,
        });
      });
  }

  render() {
    return (
      <Switch
        onChange={this.handleChange}
        checked={this.state.tutorialMode}
        id="normal-switch"
      />
    );
  }
}

export default TutorialSetting;
